var _desc, _defs, _rect, _text, _text2, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagramCalmCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 880 620",
    width: 880,
    height: 620,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "Calm core, wild edges") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "d"
  }, "Two concentric diagrams. In a system, deterministic domain logic and the event log sit at the core, adapters and ports around it, and the edge faces users, third parties, the network and time. In a team, the agreed way of working and product goal sit at the core, the delivery manager and product lead act as adapters, and the edge faces HiPPOs, other teams, procurement and quick asks. Jagged arrows of uncertainty stop at the edge.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "ah",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#52514e"
  })), /*#__PURE__*/React.createElement("marker", {
    id: "ahO",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#eb6834"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 880,
    height: 620,
    fill: "#fcfcfb"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 38,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "start"
  }, "Calm core, wild edges")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 62,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Keep the middle deterministic. Let the uncertainty arrive, and stop, at the borders.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "panel-system"
  }, /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 116,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "A system"), /*#__PURE__*/React.createElement("circle", {
    id: "panel-system-edge",
    cx: 220,
    cy: 340,
    r: 160,
    fill: "#fff6f1",
    stroke: "#eb6834",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "panel-system-adapters",
    cx: 220,
    cy: 340,
    r: 106,
    fill: "#ddf3ea",
    stroke: "#1baf7a",
    strokeWidth: 2,
    strokeDasharray: "7 4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "panel-system-core",
    cx: 220,
    cy: 340,
    r: 58,
    fill: "#e3eefb",
    stroke: "#2a78d6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 327,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Domain logic"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 344,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "and event log"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 361,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "(deterministic)"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 258,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Adapters"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 274,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "and ports"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 214,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "The edge"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 462,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "middle"
  }, "absorbs the"), /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 478,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "middle"
  }, "uncertainty"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-system-uncertainty-0",
    points: "75.0,195.0 84.2,195.8 80.7,209.2 94.1,205.6 90.6,219.1 104.0,215.5 104.7,224.7",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70.1,
    y: 180.1,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Users"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-system-uncertainty-1",
    points: "365.0,195.0 364.2,204.2 350.8,200.7 354.4,214.1 340.9,210.6 344.5,224.0 335.3,224.7",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 369.9,
    y: 180.1,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Third parties"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-system-uncertainty-2",
    points: "365.0,485.0 355.8,484.2 359.3,470.8 345.9,474.4 349.4,460.9 336.0,464.5 335.3,455.3",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 369.9,
    y: 511.9,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "The network"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-system-uncertainty-3",
    points: "75.0,485.0 75.8,475.8 89.2,479.3 85.6,465.9 99.1,469.4 95.5,456.0 104.7,455.3",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 70.1,
    y: 511.9,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Time"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "panel-team"
  }, /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 116,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "A team"), /*#__PURE__*/React.createElement("circle", {
    id: "panel-team-edge",
    cx: 660,
    cy: 340,
    r: 160,
    fill: "#fff6f1",
    stroke: "#eb6834",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "panel-team-adapters",
    cx: 660,
    cy: 340,
    r: 106,
    fill: "#ddf3ea",
    stroke: "#1baf7a",
    strokeWidth: 2,
    strokeDasharray: "7 4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "panel-team-core",
    cx: 660,
    cy: 340,
    r: 58,
    fill: "#e3eefb",
    stroke: "#2a78d6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 327,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Agreed way"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 344,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "of working and"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 361,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "product goal"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 258,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Delivery manager"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 274,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "and product lead"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 214,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#52514e",
    textAnchor: "middle"
  }, "The edge"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 462,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "middle"
  }, "absorbs the"), /*#__PURE__*/React.createElement("text", {
    x: 660,
    y: 478,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "middle"
  }, "uncertainty"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-team-uncertainty-0",
    points: "515.0,195.0 524.2,195.8 520.7,209.2 534.1,205.6 530.6,219.1 544.0,215.5 544.7,224.7",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 510.1,
    y: 180.1,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "HiPPOs"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-team-uncertainty-1",
    points: "805.0,195.0 804.2,204.2 790.8,200.7 794.4,214.1 780.9,210.6 784.5,224.0 775.3,224.7",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 809.9,
    y: 180.1,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Other teams"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-team-uncertainty-2",
    points: "805.0,485.0 795.8,484.2 799.3,470.8 785.9,474.4 789.4,460.9 776.0,464.5 775.3,455.3",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 809.9,
    y: 511.9,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "Procurement"), /*#__PURE__*/React.createElement("polyline", {
    id: "panel-team-uncertainty-3",
    points: "515.0,485.0 515.8,475.8 529.2,479.3 525.6,465.9 539.1,469.4 535.5,456.0 544.7,455.3",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5,
    strokeLinejoin: "round",
    markerEnd: "url(#ahO)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 510.1,
    y: 511.9,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 600,
    fill: "#0b0b0b",
    textAnchor: "middle"
  }, "\u201CQuick asks\u201D"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "legend"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 581,
    width: 22,
    height: 14,
    rx: 3,
    fill: "#e3eefb",
    stroke: "#2a78d6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 592,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Core: deterministic"), /*#__PURE__*/React.createElement("rect", {
    x: 191.89999999999998,
    y: 581,
    width: 22,
    height: 14,
    rx: 3,
    fill: "#ddf3ea",
    stroke: "#1baf7a",
    strokeWidth: 2,
    strokeDasharray: "7 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 221.9,
    y: 592,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Adapters: translate the outside"), /*#__PURE__*/React.createElement("rect", {
    x: 433,
    y: 581,
    width: 22,
    height: 14,
    rx: 3,
    fill: "#fde6dc",
    stroke: "#eb6834",
    strokeWidth: 2,
    strokeDasharray: "2 4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 463,
    y: 592,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Edge: uncertainty arrives"), /*#__PURE__*/React.createElement("polyline", {
    points: "637.5,588 643.5,582 649.5,594 655.5,584 663.5,588",
    fill: "none",
    stroke: "#eb6834",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 671.5,
    y: 592,
    fontFamily: "Avenir Next, Helvetica Neue, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 400,
    fill: "#52514e",
    textAnchor: "start"
  }, "Uncertainty"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramCalmCore);
export default __webpack_public_path__ + "static/media/diagram-calm-core.7275debdfb495bd74eb960191b5737e5.svg";
export { ForwardRef as ReactComponent };